import { render, staticRenderFns } from "./EventItemVariationCategory.vue?vue&type=template&id=2dad587c&scoped=true"
import script from "./EventItemVariationCategory.vue?vue&type=script&lang=js"
export * from "./EventItemVariationCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dad587c",
  null
  
)

export default component.exports